module.exports = __webpack_public_path__ + "static/media/copilot-cert-thumb.0b57d938.png";